import { ReactNode, useEffect } from "react";
import TopNavBar from "./TopNavBar";
import { Outlet, useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import ResolutionScreen from "@components/common/ResolutionScreen";
import ProductsNav from "./ProductsNav/ProductsNav";
import styled from "styled-components";
import CookiesPopup from "../CookiesPopup/cookiesPopup";

import {
  Footer,
  ProfileModalProvider,
  UserModal,
  NoAccessScreen,
} from "@ucchub/ui";
import AuthenticationService from "@services/AuthenticationService";
import { getBaseUrl } from "@utils/isDev";

const BASE_URL = getBaseUrl();

interface DashShellProps {
  hideCrumbs?: boolean;
  children?: ReactNode;
}

const BottomActionBar = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 10;
`;

const DashShell = ({ children }: DashShellProps) => {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith("/cloud-numbers/numbers")) {
      // User is navigating away from my numbers, clear saved cease numbers payload
      sessionStorage.removeItem("ceaseNumbers");
    }
  }, [location.pathname]);

  return (
    <ProfileModalProvider
      authenticationService={AuthenticationService}
      baseUrl={BASE_URL}
    >
      <UserModal />
      <TopNavBar />
      <ResolutionScreen>
        <NoAccessScreen>
          <ErrorBoundary>
            <ProductsNav>
              <Outlet />
              {!!children && <div className="vf-container">{children}</div>}
              <BottomActionBar id="bottomActionBar" />
              <Footer />
              <CookiesPopup />
            </ProductsNav>
          </ErrorBoundary>
        </NoAccessScreen>
      </ResolutionScreen>
    </ProfileModalProvider>
  );
};

export default DashShell;
